import { baseChartConfig } from "@/config/baseChartConfig";
import Highcharts from "highcharts";

const dispensedFeedSeries = function(data, seriesName, color) {
  return {
    visible: true,
    name: seriesName,
    data: data,
    linkedTo: ":previous",
    dashStyle: "Solid",
    color: color,
    zIndex: 0,
    marker: {
      enabled: false,
    },
  };
};
const feedLimitSeries = function(data, seriesName, color) {
  return {
    name: seriesName,
    data: data,
    zIndex: 1,
    dashStyle: "dash",
    color: color,
    visible: true,
  };
};

const chartMeasurements = {
  spacingBottom: 10,
  marginBottom: 30,
  spacingTop: 15,
  spacingLeft: 1,
  spacingRight: 1,
  height: "40%",
};

const feedChartOptions = JSON.parse(JSON.stringify(baseChartConfig));

const SHOW_Y_AXIS_ON_EMPTY = false;
feedChartOptions.chart = {
  ...chartMeasurements,
  type: "spline",
  resetZoomButton: {
    theme: {
      zIndex: 2000,
    },
  },
  zoomType: "x",
};

feedChartOptions.yAxis = {
  title: {
    text: "Feed (kg)",
  },
  labels: {
    x: -5,
    y: 3,
  },
  tickAmount: 5,
  showLastLabel: true,
  opposite: false,
  showEmpty: SHOW_Y_AXIS_ON_EMPTY,
};

export const feedConfig = {
  chart_options: feedChartOptions,
  series_generators: {
    feed_limit: feedLimitSeries,
    dispensed_feed: dispensedFeedSeries,
  },
  yAxis: {
    title: {
      text: "Feed (Kg)",
    },
    opposite: false,
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
  series: [feedLimitSeries, dispensedFeedSeries],
};

const actualABWSeries = {
  name: "feed",
  type: "column",
  zIndex: 1,
  // color: color,
  dashStyle: "dash",
  visible: true,
  stack: 0,
};

const actualABWBioSeries = {
  name: "abw",
  type: "spline",
  zIndex: 1,
  // color: color,
  dashStyle: "dash",
  visible: true,
  stack: 0,
};

const abwChartOptions = JSON.parse(JSON.stringify(baseChartConfig));

abwChartOptions.yAxis = [
  {
    gridLineWidth: 0,
    tickAmount: 5,
    title: {
      text: "ABW (g)",
      style: {
        color: "#000000",
      },
    },
    labels: {
      style: {
        color: Highcharts.getOptions().colors[1],
      },
      x: -5,
      y: 3,
    },
    showLastLabel: true,
    opposite: false,
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
  {
    gridLineWidth: 1,
    tickAmount: 5,
    title: {
      text: "Biomass (kg)",
      style: {
        color: Highcharts.getOptions().colors[1],
      },
    },
    labels: {
      style: {
        color: "#000000",
      },
      x: 5,
      y: 3,
    },
    showLastLabel: true,
    opposite: true,
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
];

abwChartOptions.chart = {
  ...chartMeasurements,
  resetZoomButton: {
    theme: {
      zIndex: 2000,
    },
  },
  zoomType: "x",
};
export const ABWConfig = {
  chart_options: abwChartOptions,
  series_generators: {
    actual_abw: actualABWSeries,
    biomass: actualABWBioSeries,
  },
};

const doChartOptions = JSON.parse(JSON.stringify(baseChartConfig));
doChartOptions.yAxis = [
  {
    gridLineWidth: 1,
    tickAmount: 5,
    title: {
      text: "Dispensed Feed (kg)",
      style: {
        color: Highcharts.getOptions().colors[1],
      },
    },
    labels: {
      style: {
        color: "#000000",
      },
      x: 3,
      y: 3,
    },
    offset: 20,
    opposite: true,
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
  {
    gridLineWidth: 1,
    tickAmount: 5,
    title: {
      text: "DO (mg/L)",
      style: {
        color: Highcharts.getOptions().colors[1],
      },
    },
    plotLines: [
      {
        color: "red",
        dashStyle: "dash",
        width: 2,
        value: 2.5,
        label: {
          rotation: 0,
          y: 15,
          style: {
            fontStyle: "italic",
          },
          text: "Low DO limit",
        },
        zIndex: 3,
      },
    ],
    labels: {
      style: {
        color: "#000000",
      },
      x: -5,
      y: 3,
    },
    opposite: false,
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
];

doChartOptions.chart = {
  ...chartMeasurements,
  resetZoomButton: {
    theme: {
      zIndex: 2000,
    },
  },
  zoomType: "x",
  yAxis: {
    showEmpty: SHOW_Y_AXIS_ON_EMPTY,
  },
};
export const doConfig = {
  chart_options: doChartOptions,
};

export default {
  feedConfig,
  ABWConfig,
  doConfig,
};
